<template>
  <div>
    <div v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>

    <v-tabs
      v-else
      background-color="primary"
      dark
      slider-color="yellow"
      :value="activeTab"
      @change="updateTab"
    >
      <v-tab v-for="(item, index) in items" :key="index">{{ item.name }}</v-tab>
      <v-tabs-items v-model="activeTab" style="height:100%" touchless>
        <v-tab-item
          v-for="(item, index) in items"
          :key="index"
        >
          <component
            style="height:100%"
            :loading="loading"
            v-bind:is="item.component"
            :location="location"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
  // Components
  import LocationStock from '@/components/Logistics/Locations/Stock'

  // Services
  import locationService from '@/services/logistics/location'
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    components: {
      LocationStock,
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      items () {
        let items = []

        items.push({
          name: 'Stocks',
          component: 'LocationStock'
        })
        return items
      }
    },

    mixins: [
    ],

    data () {
      return {
        loading: false,

        activeTab: null,

        location: null
      }
    },

    created () {
      this.loading = true

      locationService
        .get(this.$route.params.id)
        .then(({ data }) => {
          this.location = data.data

          if (this.location.name && this.$route.name === 'LogisticsLocation') {
            this.$store.commit('UPDATE_TITLE', `Location - ${this.location.name}`)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    methods: {
      ...mapMutations('tabs', ['SET_ITEMS']),

      updateTab (value) {
        this.activeTab = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Logistics/Locations/Location.vue